import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IFilter = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="27"
            viewBox="0 0 31 27"
            fill={props.color ?? '#37474F'}
          >
            <line
              x1="4.55151"
              y1="6.53125"
              x2="26.2287"
              y2="6.53125"
              stroke="#37474F"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="8.69507"
              y1="11.5527"
              x2="22.0853"
              y2="11.5527"
              stroke="#37474F"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="14.0227"
              y1="16.5742"
              x2="16.7582"
              y2="16.5742"
              stroke="#37474F"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IFilter;
